module.exports = __webpack_public_path__ + "static/images/warning-red.33yBMhd.svg";